import { useCallback, useEffect, useState } from 'react'

import { getKyousouApiClient } from '../../../services/network'

export const useGuideStatus = (): {
  initialized: boolean
  completedActions: string[]
} => {
  const apiClient = getKyousouApiClient()
  const [completedActions, setCompletedActions] = useState<string[]>([])
  const [initialized, setInitialized] = useState<boolean>(false)

  const load = useCallback(async () => {
    try {
      await apiClient.guide
        .checkList()
        .then((response) => {
          setCompletedActions(response.data.completedActions)
        })
        .finally(() => {
          setInitialized(true)
        })
    } catch (e) {
      console.error(e)
      return null
    }
  }, [])

  useEffect(() => {
    load()
  }, [])

  return { initialized, completedActions }
}
